import { BaseEdge, EdgeLabelRenderer, type Edge, type EdgeProps } from '@xyflow/react'
import { edgeLabelPlacement } from '@/frontend/features/Fde/graphEdgeLabelPlacement'
import type { GraphPoint } from '@/frontend/features/Fde/useOntologyGraphLayout'

export interface OntologyEdgeData extends Record<string, unknown> {
  points: GraphPoint[]
  active: boolean
  dimmed: boolean
  number: number | null
}

export type OntologyFlowEdge = Edge<OntologyEdgeData, 'ontology'>

function edgePath(points: GraphPoint[], fallback: GraphPoint[]) {
  const route = points.length > 1 ? points : fallback
  return route.map((point, index) => `${index === 0 ? 'M' : 'L'} ${point.x} ${point.y}`).join(' ')
}

export default function OntologyGraphEdge({ id, data, markerEnd, sourceX, sourceY, targetX, targetY }: EdgeProps<OntologyFlowEdge>) {
  const points = data?.points || []
  const route = points.length > 1 ? points : [{ x: sourceX, y: sourceY }, { x: targetX, y: targetY }]
  const path = edgePath(route, route)
  const marker = data?.active ? edgeLabelPlacement(route, { width: 22, height: 22 }) : null
  return (
    <>
      <BaseEdge id={id} path={path} markerEnd={markerEnd} interactionWidth={18} className={data?.dimmed ? 'fde-ontology-edge fde-ontology-edge-dimmed' : data?.active ? 'fde-ontology-edge fde-ontology-edge-active' : 'fde-ontology-edge'} />
      {marker && data?.number && <EdgeLabelRenderer><span
        className="nodrag nopan pointer-events-none absolute z-30 flex size-[22px] items-center justify-center rounded-full border border-primary bg-background text-[9px] font-semibold text-foreground shadow-sm"
        style={{ transform: `translate(-50%, -50%) translate(${marker.x}px, ${marker.y}px)` }}
      >{data.number}</span></EdgeLabelRenderer>}
    </>
  )
}
